module.exports = __webpack_public_path__ + "img/alarm.adb7612f.jpg";